import type { ExamReport } from "@/types/exam"
import { ref, shallowRef } from "vue"

const visible = ref(false)
const data = shallowRef<Partial<ExamReport> | null>(null)

export function useShareExamReport() {
	function open(examReport: Partial<ExamReport>) {
		data.value = examReport
		visible.value = true
	}

	function close() {
		visible.value = false
		data.value = null
	}

	return {
		visible,
		data,
		open,
		close
	}
}
